import { Injectable } from '@angular/core';
import { fromJS } from 'immutable';
import { ActivatedRoute } from '@angular/router';
import { flatten, forEach, intersectionBy, map, some, uniqBy } from 'lodash';
import { LayoutProviderService } from '@nrwl/common-lib';
import { BaseWizardService } from './services/base.wizard.service';
import { SitesWizardService } from './services/sites/sites.wizard.service';
import { UserWizardService } from './services/user/user.wizard.service';

@Injectable({
  providedIn: 'root'
})
export class WizardLauncherService {
  service: any;
  canManageUsersResults = false;
  wizardConfig: any;
  activeLayout: any; // full workspace

  perspectiveId: any;

  constructor(
    private readonly siteswizardService: SitesWizardService,
    private readonly baseWizardService: BaseWizardService,
    private readonly layoutProviderService: LayoutProviderService,
    private readonly userWizardService: UserWizardService,
    private readonly activeRoute: ActivatedRoute
  ) {
    this.service = this.baseWizardService;

    this._getLayout$();
  }

  get classes() {
    return this.service.classes;
  }

  get options() {
    return this.service.options;
  }

  get visible() {
    return this.options.visible;
  }

  get output() {
    return this.service.output;
  }

  _getType() {
    return this.wizardConfig.valuesFixed.type;
  }

  _getService(type) {
    switch (type) {
      case 'sites':
        return this.siteswizardService;
      case 'user':
        return this.userWizardService;
      default:
        return this.baseWizardService;
    }
  }

  launchWizard(
    wizardId?,
    defaultParamsById = {},
    onSuccess = (object, output) => {},
    onFail = errorDetails => {}
  ) {
    const config = this.wizardConfig[wizardId].wizardConfig;
    this.service = this._getService(config.valuesFixed.type);

    this.service.openWizard(wizardId, config, defaultParamsById, onSuccess, onFail);
    if (this.service._getId(wizardId) !== this.service.id) {
      this.toggleClose(() => {
        setTimeout(() => {
          this.service = this._getService(this._getType());
          this.service.canManageUsersResults = this.canManageUsersResults;
        }, 0);
      });
    }
  }

  toggleClose(callBack = () => {}) {
    this.service.toggleClose(callBack);
  }

  _getDefaultParams(arrayData, settings) {
    const defaultParams = {};
    forEach(settings, (item, key) => {
      switch (item.type) {
        case 'intersection':
          defaultParams[key] = this._getArraysIntersection(arrayData, item.key, item.id);
          break;
        case 'combined':
          defaultParams[key] = this._getArrayCombined(arrayData, item.key, item.id);
          break;
        default:
          defaultParams[key] = map(arrayData, item.id);
      }
    });

    return defaultParams;
  }

  _getArraysIntersection(arrayData, key, id) {
    const array: any = map(arrayData, key);
    let result = array[0];

    for (let i = 0; i < array.length; i++) {
      result = intersectionBy(result, array[i], id);
    }

    return result;
  }

  _getArrayCombined(arrayData, key, id) {
    return uniqBy(flatten(map(arrayData, data => data[key])), id);
  }

  openWizardById(wizardId, settings) {
    const arrayData: any = settings.data;
    this.canManageUsersResults = some(arrayData, item => item.canManageUsersResults);
    const defaultParams = this._getDefaultParams(arrayData, settings.default);
    // close any previously open wizard (this is important for discarding internal state of WizardService)
    //Since closing the existing wizard logic is added in Wizard Service commenting this line
    //this.wizardService.toggleClose();
    this.launchWizard(wizardId, defaultParams, settings.onSuccess);
  }

  private _getLayout$() {
    this.activeRoute.params.subscribe(values => {
      this.layoutProviderService.getLayout().then(layout => {
        this.activeLayout = fromJS(layout);
        this.wizardConfig = this.activeLayout.get('registry').get('wizard').toJS();
      });
    });
  }
}
